import { Paper, TextField, Theme, Typography } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps } from '../../types/types';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             // minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         }
//     }),
// );

export default function ImprenditoreProfessionista(props: DefaultInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const { state } = props;
    return (
        <Paper className={gClasses.mainPaper}>
            <SectionTitle text="Imprenditore/Professionista"></SectionTitle>
            <TextField
                label="Imprenditore/professionista"
                value={state.nomeCognome}
                className={gClasses.textFieldReadOnly}
                InputLabelProps={{
                    shrink: true,
                    disabled: true
                }}
                margin="normal"
            />
            <Typography variant="h5">Redditi</Typography>
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E98"
                label="Pensione"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E98}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E99"
                label="Lav. dipendente e assimilati"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E99}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E100"
                label="Assimilati lav. dipendente"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E100}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E101"
                label="Diversi lettere i) e l)"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E101}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E102"
                label="Fabbricati locati"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E102}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E103"
                label="Altri"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E103}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E104"
                label="Abitazione principale"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E104}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E105"
                label="Redditi a cedolare secca"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E105}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Reddito complessivo"
                value={state.imprenditoreProfessionista.redditi_E18}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Redd. compl. per detraz."
                value={state.imprenditoreProfessionista.redditi_E19}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Oneri deducibili"
                value={state.liquidazioneIrpef.altriDatiPersonali_L101}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Reddito imponibile"
                value={state.imprenditoreProfessionista.redditi_I8}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Irpef lorda"
                value={state.imprenditoreProfessionista.redditi_I9}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <Typography variant="h5">Detrazioni</Typography>
            <NumberField
                name=""
                label="Familiari a carico"
                value={state.imprenditoreProfessionista.redditi_I11}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Lavoro dipend."
                value={state.imprenditoreProfessionista.redditi_I12}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Pensione"
                value={state.imprenditoreProfessionista.redditi_I13}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Lav. non dipend."
                value={state.imprenditoreProfessionista.redditi_I14}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Altre"
                value={state.liquidazioneIrpef.altriDatiPersonali_L102}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Tot. Detrazioni"
                value={state.imprenditoreProfessionista.redditi_I16}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Irpef netta"
                value={state.imprenditoreProfessionista.redditi_M12}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <Typography variant="h5">Addizionali Irpef</Typography>
            <NumberField
                name=""
                label="Regionale"
                value={state.imprenditoreProfessionista.redditi_K16}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Comunale"
                value={state.imprenditoreProfessionista.redditi_M16}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
        </Paper>
    );
}